import { useLocation } from 'react-router-dom';


export function useRouteState<T extends Object>(defaultValue = {}) {
    return (useLocation().state) as T || defaultValue;
}
